import fallbackIt from '../images/automate_it.jpeg'
import fallbackAstroid from '../images/javier-miranda-SYRNx7SLHCk-unsplash.jpg'
import sudokuSolver from '../images/sudokuSolver_AI.png'
import fallbackChessboard from '../images/leanna-cushman-_GF3sgGkSB0-unsplash.jpg'

const imageCreditsList = [
  { photographer: "Javier Miranda", 
    profileUrl: "https://unsplash.com/@nuvaproductions", 
    description: "Alien planet and Asteroids", 
    imageUrl: 'https://images.unsplash.com/photo-1697325320142-28beaededbf3?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=3732', 
    fallbackPath: fallbackAstroid
  },{ 
    photographer: "AI Generated", 
    profileUrl: "", 
    description: "Machine solving Sudoku",
    imageUrl: null,
    fallbackPath: sudokuSolver
  },{ 
    photographer: "AI Generated", 
    profileUrl: "", 
    description: "IT Workplace with Robot Working on Computer",
    imageUrl: null,
    fallbackPath: fallbackIt
  }
];

export default imageCreditsList